module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_library.js
 ** module id = 80
 ** module chunks = 1
 **/